export default __webpack_public_path__ + "static/media/praticidade-cliente.af13a0b9.svg";